import './recreate-request.scss';

import { Checkbox, Modal } from 'antd';
import { useState } from 'react';

import { Button, CircledImage } from '@/components/Shared/ui';
import AlertCircleIcon from '@/media/icons/alert-circle.svg?react';
import { useAppSelector } from '@/store';

import useBanksList from './hooks/useBanksList';
import useRecreate from './hooks/useRecreate';

interface IProps {
  isOpened: boolean;
  onClose: (isOpened: boolean) => void;
}

const RecreateRequest: React.FC<IProps> = ({ isOpened, onClose }) => {
  const { orderApp } = useAppSelector((state) => state.newOrder);

  const [error, setError] = useState('');

  const isRequestAutoTypeUsedAuto =
    orderApp?.productInfo.product.autoType === 2;

  const {
    banks,
    isAllBanksChecked,
    handleBankChecked,
    handleCheckAll,
    resetCheckedBanks,
    isCommercialChecked,
    toggleIsCommercialChecked,
    resetIsCommercialChecked
  } = useBanksList({ isRequestAutoTypeUsedAuto, setError });
  const { recreateLoading, handleSubmit } = useRecreate({ handleClose });

  function handleClose() {
    onClose(false);
    resetCheckedBanks();
    resetIsCommercialChecked();
  }

  return (
    <Modal
      centered
      mask={{ closable: true }}
      className="recreate-request"
      classNames={{
        header: 'recreate-request__header'
      }}
      title="Переотправить заявку в банк"
      open={isOpened}
      onCancel={handleClose}
      footer={null}
    >
      <div className="recreate-request__content">
        <div className="recreate-request__control-header">
          <label className="recreate-request__bank">
            <Checkbox checked={isAllBanksChecked} onChange={handleCheckAll} />
            <span className="recreate-request__bank-name recreate-request__bank-name--font-normal">
              Выбрать все
            </span>
          </label>
          <label className="recreate-request__bank">
            <Checkbox
              checked={isCommercialChecked}
              onChange={toggleIsCommercialChecked}
              disabled={isRequestAutoTypeUsedAuto}
            />
            <span className="recreate-request__bank-name recreate-request__bank-name--font-normal">
              Авто с первичной регистрацией
            </span>
          </label>
        </div>

        {banks.map((bank, index) => (
          <label key={bank.name} className="recreate-request__bank">
            <Checkbox
              checked={bank.checked}
              onChange={() => handleBankChecked(index)}
            />
            <div className="recreate-request__bank-content">
              <CircledImage size={40} src={bank.icon} alt={bank.name} />
              <p className="recreate-request__bank-name">{bank.name}</p>
            </div>
          </label>
        ))}

        {error && (
          <p className="recreate-request__error">
            <AlertCircleIcon />
            {error}
          </p>
        )}
      </div>

      <div className="recreate-request__actions">
        <Button onClick={handleClose}>Отмена</Button>
        <Button
          variant="filled-red"
          onClick={() => {
            if (banks.some((item) => item.checked)) {
              handleSubmit(banks, isCommercialChecked);
            } else {
              setError('Пожалуйста, выберите банк');
            }
          }}
          disabled={!!error}
          isLoading={recreateLoading}
        >
          Отправить
        </Button>
      </div>
    </Modal>
  );
};

export default RecreateRequest;
